import {call, put} from 'redux-saga/effects';
import UsersActions from '../redux/UsersRedux';
import MessagesActions from '../redux/MessagesRedux';

export function * getUsers(api, action) {
  const response = yield call(api.getUsers, {...action.props});

  if (response.ok) {
    yield put(UsersActions.usersSuccess({...response.data, ...action.props}));
  } else {
    yield put(UsersActions.usersFailure(response.data && response.data.title ? response.data.title : response.problem));
    yield put(MessagesActions.messagesShow({type: 'error', code: response.status, title: response.data && response.data.title ? response.data.title : response.problem}));
  }
}
